import React from "react";
import { Button, ButtonVariant, Link } from "@merge-api/merge-javascript-shared";

import { AuthLayout } from "../AuthLayouts";

// mailto with pre-filled subject; recipient blank so the user types their admin's address.
const ADMIN_INVITE_MAILTO =
  "mailto:?subject=Request%20for%20Merge%20invite&body=Hi%2C%0A%0AI%20tried%20to%20sign%20in%20to%20Merge%20via%20SSO%20but%20don%27t%20have%20an%20account%20yet.%20Could%20you%20send%20me%20an%20invite%3F%0A%0AThanks";

const SamlNoAccountFound = () => {
  return (
    <AuthLayout
      title="No account found"
      description={
        <>
          <p>We couldn't find your account in your organization's SSO configuration.</p>
          <p>Please contact your Merge organization administrator and request an invite.</p>
        </>
      }
      finePrint={
        <>
          If you want SSO for your organization, please contact{" "}
          <Link href="mailto:support@merge.dev">support@merge.dev</Link>.
        </>
      }
    >
      <Button
        type="button"
        fullWidth
        variant={ButtonVariant.PrimaryGray}
        onClick={() => {
          window.location.href = ADMIN_INVITE_MAILTO;
        }}
      >
        Contact your admin
      </Button>
    </AuthLayout>
  );
};

export default SamlNoAccountFound;
